import { getStandardizedName } from 'common/utils/stringUtils'

export const getOneTimeProductSlugs = ({ oneTimeProductsData = {}, productId }) => {
  let oneTimeProductSlugs = {}
  Object.values(oneTimeProductsData || {}).forEach((product) => {
    if (!productId || product?.id !== productId) {
      const stdSlug = getStandardizedName(product?.slug)
      oneTimeProductSlugs[stdSlug] = true
    }
  })
  return oneTimeProductSlugs
}
